<template>
  <div
    v-show="selectedFilters.length"
    class="selected-filter-chips flex flex-wrap gap-2 text-sm font-normal"
  >
    <div
      v-for="selectedFilter in selectedFilters"
      :key="`${selectedFilter.key}-${selectedFilter.value}`"
      class="selected-filter-chips-item rounded-3xl border border-primary-200 bg-primary-50
        px-3 py-1.5"
    >
      {{ $t(selectedFilter.label) }}: {{ selectedFilter.value }}
      <button @click="resetFilter(selectedFilter)">
        <icons-icon-close size="sm" />
      </button>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { DeepReadonly } from "vue";
import type { IFilterManager } from "~/modules/catalog/classes/IFilterManager";

const props = defineProps<{
  readFilterManager: DeepReadonly<IFilterManager>;
  editableFilterManager: IFilterManager;
}>();

const emit = defineEmits<{
  (
    _e: "onFilterReset",
    _filter: ReturnType<typeof props.readFilterManager.selectedFilters>[number],
  ): void;
}>();

const selectedFilters = computed<
  ReturnType<typeof props.readFilterManager.selectedFilters>
>(() => props.readFilterManager.selectedFilters());

function resetFilter(
  filter: ReturnType<typeof props.readFilterManager.selectedFilters>[number],
): void {
  props.editableFilterManager.resetFilter(filter);
  emit("onFilterReset", filter);
}
</script>
